import { render, staticRenderFns } from "./FornecedorCadastro.vue?vue&type=template&id=2ef60a0e"
import script from "./FornecedorCadastro.vue?vue&type=script&lang=js"
export * from "./FornecedorCadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports